var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('a',{staticClass:"mr-1",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.$emit('on-back')}}},[_c('icon',{attrs:{"type":"md-arrow-back"}})],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }